export default __webpack_public_path__ + "static/media/l4.0363edf4.png";